import React from "react";
import "./WSRandGuidelines.css";
import bg from "../../Assets/large.jpeg";

const WSRandGuidelines = () => {
  return (
    <div className="container WSRandGuidelines-container py-5">
      <div className="row align-items-center">
        {/* Santa Image */}
        <div className="col-md-6 text-center mb-4 mb-md-0">
          <img
            src={bg}
            alt="Santa with gift"
            className="img-fluid WSRandGuidelines-santa"
          />
        </div>

        {/* Text and Buttons */}
        <div className="col-md-6">
          <h1
            className="WSRandGuidelines-heading fw-bold"
            style={{ color: "#2782A0" }}
          >
            Workshop
          </h1>
          <h5
            className="WSRandGuidelines-subheading  fw-bold mt-3"
            style={{ color: "#FDB92F" }}
          >
            Requirements & Guidelines
          </h5>
          <p className="WSRandGuidelines-description text-secondary mt-3">
            <ul>
              <li>
                Participants are encouraged to bring their personal laptops (for
                backup).
              </li>
              <li>Minimum 6 GB RAM is recommended.</li>
              <li>
                Usage of an external mouse is preferable over an inbuilt
                trackpad.
              </li>
            </ul>
          </p>
        </div>
      </div>
    </div>
  );
};

export default WSRandGuidelines;
